import { useEffect } from "react";

import NoMoneyIcon from "@mui/icons-material/CreditCardOff";
import GloveIcon from "@mui/icons-material/Handshake";
import LockIcon from "@mui/icons-material/Troubleshoot";
import { Box, Grid, Link, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";

// import gtag from "ga-gtag";
// import { v4 as uuid } from "uuid";

const QuestionAcceptTermsDisplay = props => {
  const { question, onAnswerSelected, startNextTimer } = props;

  const theme = useTheme();

  const defaultDelay = 50;

  useEffect(() => {
    if (question && question.answerValue == null) {
      onAnswerSelected(["yes"]);
      startNextTimer(defaultDelay);
    }
  }, [question, startNextTimer, onAnswerSelected]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: theme.spacing(2),
          }}
        >
          <LockIcon color="primary" fontSize="large" />
          <Typography
            variant={"h5"}
            sx={{ marginTop: theme.spacing(0.5), marginLeft: theme.spacing(1) }}
          >
            We search for your best opportunities.
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: theme.spacing(2),
          }}
        >
          <GloveIcon color="primary" fontSize="large" />
          <Typography
            variant={"h5"}
            sx={{ marginTop: theme.spacing(0.25), marginLeft: theme.spacing(1) }}
          >
            Our staff helps you connect.
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: theme.spacing(2),
          }}
        >
          <NoMoneyIcon color="primary" fontSize="large" />
          <Typography
            variant={"h5"}
            sx={{ marginTop: theme.spacing(0.25), marginLeft: theme.spacing(1) }}
          >
            This service is entirely free.
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="body2"
          sx={{
            textAlign: "center",
            margin: theme.spacing(1),
            marginTop: theme.spacing(1),
            userSelect: "none",
          }}
        >
          {"By clicking Finish you accept our "}
          <Link
            href={`${
              window.location.origin.includes("localhost")
                ? `https://dev.omnisciahealth.coach`
                : window.location.origin
            }/assets/legal/TOS.html`}
            to="route"
            target="_blank"
            sx={{ color: theme.palette.primary.main }}
            onClick={() => {
              //   gtag("event", "user_onboarding_TOS", {
              //     invite_key: inviteKey,
              //   });
            }}
          >
            Terms of Service
          </Link>
          {` and `}
          <Link
            href={`${
              window.location.origin.includes("localhost")
                ? `https://dev.omnisciahealth.coach`
                : window.location.origin
            }/assets/legal/privacypolicy.html`}
            to="route"
            target="_blank"
            sx={{ color: theme.palette.primary.main }}
            onClick={() => {
              //   gtag("event", "user_onboarding_privacy_policy", {
              //     invite_key: inviteKey,
              //   });
            }}
          >
            Privacy Policy
          </Link>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default QuestionAcceptTermsDisplay;
